import { Controller } from "stimulus";

export default class TitleController extends Controller {
  connect() {
    this.update()
    this.inputTarget.addEventListener('input', this.update.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener('input', this.update.bind(this))
  }

  update() {
    this.inputTarget.style.height = 'auto'
    this.inputTarget.style.height = this.inputTarget.scrollHeight + 'px'
    this.wordCountTarget.textContent = this.inputTarget.value.length
  }
} 

TitleController.targets = ["input", "wordCount"]